import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different request action types
*/
var initialstate = {
  isLoading: false,
  requests: [],
  selectedRequests: {},
  filters: {},
  pagination: {},
  sort: {},
  selectedIndex: {},
  filter: {},
  fullfillmentRequests: {},
}

export default function patient_operation(state = { ...initialstate }, action) {
  switch (action.type) {
    case ActionType.MESSAGE_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.MESSAGE_LIST:
      return {
        ...state,
        error: action.hasError,
        requests: action.requests,
        filters: action.filters,
        pagination: action.pagination,
        selectedRequests: action.selectedRequests,
        isNew: action.isNew,
        fullfillmentRequests: action.fullfillmentRequests,
        groupby: false,
        sort: action.sort,
      }
    case ActionType.MESSAGE_ROW_SELECT:
      return { ...state, selectedRequests: action.selectedRequests }
    case ActionType.MESSAGE_NEW:
      return { ...state, isNew: action.isNew }
    case ActionType.FULLFILLMENT_ROW_SELECT:
      return { ...state, fullfillmentRequests: action.fullfillmentRequests }
    case ActionType.MESSAGE_SELECT_BOX:
      return { ...state, selectedIndex: action.selectedIndex }
    case ActionType.MESSAGE_FILTER:
      return { ...state, filter: action.filter }
    case ActionType.MESSAGE_GROUP_BY:
      return { ...state, groupby: action.groupby }
    case ActionType.MESSAGE_SERVICE_ERROR:
      return { ...state, error: action.hasError, message: action.message }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
